import { handleActions } from 'redux-actions'
import { SET_PRODUCT_DETAILS_DATA, SET_PRODUCT_DETAILS_STATE } from '../constants/mallConstant'
import { handleStateChange } from '../utils'

let initState = {
  loading: false,
  errorMessage: '',
  data: {}
}

export let mallProductDetails = handleActions({
  [SET_PRODUCT_DETAILS_STATE]: handleStateChange,
  [SET_PRODUCT_DETAILS_DATA]: (state, action) => {
    let detailsData = action.payload
    let { data } = state
    Object.assign(data, { [detailsData['id']]: detailsData })
    return {
      loading: false,
      errorMessage: '',
      data
    }
  }
}, initState)

